module.exports = __webpack_public_path__ + "static/media/PdfIcon.67edc9f6.svg";